import React from "react";

function TextInput({
  labelText,
  inputName,
  inputOnChange,
  inputDefault,
  inputValue,
}) {
  return (
    <>
      <div className="sm:flex items-center mb-1.5 flex-wrap">
        <label className="" htmlFor={inputName}>
          {labelText}{" "}
        </label>
        <input
          className="outline-0 border border-slate-200 rounded-sm xl:w-64 2xl:w-80 lg:w-96  justify-start px-2 py-0.5 transition hover:border-slate-400 focus:border-slate-700"
          type="text"
          name={inputName}
          onChange={inputOnChange}
          defaultValue={inputDefault}
          value={inputValue}
        />
      </div>
    </>
  );
}

export default TextInput;
